import { MessageSquare, Users2, ShieldCheck, Briefcase, Search, Plus, Filter } from 'lucide-react';
import { cn } from '../../../../utils/helpers';

const chatCategories = [
  { id: 'business', label: 'Business', icon: Briefcase, count: 3 },
  { id: 'consulting', label: 'Consulting', icon: Users2, count: 1 },
  { id: 'networking', label: 'Networking', icon: MessageSquare, count: 5 },
  { id: 'compliance', label: 'Compliance', icon: ShieldCheck, count: 0 },
];

export default function CompanyChat() {
  return (
    <div className="h-[calc(100vh-12rem)] flex bg-white dark:bg-neutral-900 rounded-[2.5rem] border border-neutral-200 dark:border-neutral-800 overflow-hidden shadow-xl shadow-neutral-200/50">
      {/* Sidebar */}
      <div className="w-80 border-r border-neutral-100 dark:border-neutral-800 flex flex-col">
        <div className="p-6 border-b border-neutral-100 dark:border-neutral-800 space-y-4">
          <div className="flex items-center justify-between">
            <h1 className="text-xl font-bold">Company Chat</h1>
            <button className="p-2 rounded-xl bg-neutral-900 text-white hover:bg-neutral-800 transition-colors">
              <Plus className="w-4 h-4" />
            </button>
          </div>
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-neutral-400 dark:text-neutral-500" />
            <input 
              type="text" 
              placeholder="Search conversations..." 
              className="w-full pl-10 pr-4 py-2 bg-neutral-50 dark:bg-neutral-950 border-none rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-neutral-900/5 transition-all"
            />
          </div>
        </div>

        <div className="flex-1 overflow-y-auto p-4 space-y-6">
          <div className="space-y-1">
            {chatCategories.map((cat) => (
              <button 
                key={cat.id}
                className={cn(
                  "w-full flex items-center justify-between p-3 rounded-xl transition-all group",
                  cat.id === 'business' ? "bg-neutral-900 text-white" : "hover:bg-neutral-50 dark:hover:bg-neutral-950 text-neutral-600 dark:text-neutral-300"
                )}
              >
                <div className="flex items-center gap-3">
                  <cat.icon className={cn("w-5 h-5", cat.id === 'business' ? "text-white" : "text-neutral-400 dark:text-neutral-500 group-hover:text-neutral-900 dark:group-hover:text-neutral-50")} />
                  <span className="text-sm font-bold">{cat.label}</span>
                </div>
                {cat.count > 0 && (
                  <span className={cn(
                    "text-[10px] font-bold px-2 py-0.5 rounded-full",
                    cat.id === 'business' ? "bg-white dark:bg-neutral-900 text-neutral-900 dark:text-neutral-50" : "bg-neutral-100 dark:bg-neutral-800 text-neutral-500 dark:text-neutral-400"
                  )}>
                    {cat.count}
                  </span>
                )}
              </button>
            ))}
          </div>

          <div className="space-y-4">
            <div className="flex items-center justify-between px-2">
              <h3 className="text-[10px] font-bold text-neutral-400 dark:text-neutral-500 uppercase tracking-widest">Recent Chats</h3>
              <Filter className="w-3 h-3 text-neutral-400 dark:text-neutral-500" />
            </div>
            <div className="space-y-1">
              {[
                { name: 'Marketing Team', lastMsg: 'The Q4 campaign is ready...', time: '12m', unread: true },
                { name: 'Legal Consult', lastMsg: 'Please review the new terms.', time: '1h', unread: false },
                { name: 'Industry Experts', lastMsg: 'Market trends are shifting...', time: '3h', unread: false },
              ].map((chat, i) => (
                <button key={i} className="w-full flex items-center gap-4 p-3 rounded-2xl hover:bg-neutral-50 dark:hover:bg-neutral-950 transition-all text-left">
                  <div className="w-10 h-10 rounded-full bg-neutral-100 dark:bg-neutral-800 flex-shrink-0 flex items-center justify-center font-bold text-neutral-500 dark:text-neutral-400">
                    {chat.name[0]}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between mb-0.5">
                      <p className="text-sm font-bold truncate">{chat.name}</p>
                      <span className="text-[10px] text-neutral-400 dark:text-neutral-500">{chat.time}</span>
                    </div>
                    <p className={cn("text-xs truncate", chat.unread ? "text-neutral-900 dark:text-neutral-50 font-medium" : "text-neutral-500 dark:text-neutral-400")}>
                      {chat.lastMsg}
                    </p>
                  </div>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Chat Area Placeholder */}
      <div className="flex-1 bg-neutral-50 dark:bg-neutral-950 flex flex-col items-center justify-center p-12 text-center space-y-4">
        <div className="w-20 h-20 bg-white dark:bg-neutral-900 rounded-[2rem] border border-neutral-100 dark:border-neutral-800 flex items-center justify-center shadow-lg shadow-neutral-200/50">
          <MessageSquare className="w-10 h-10 text-neutral-200" />
        </div>
        <div>
          <h2 className="text-xl font-bold text-neutral-900 dark:text-neutral-50">Select a Conversation</h2>
          <p className="text-sm text-neutral-500 dark:text-neutral-400 max-w-xs mx-auto mt-2">
            Choose a chat from the sidebar to start collaborating with your team or industry experts.
          </p>
        </div>
        <button className="px-6 py-3 bg-neutral-900 text-white rounded-2xl text-sm font-bold hover:bg-neutral-800 transition-all shadow-lg shadow-neutral-900/20">
          Start New Chat
        </button>
      </div>
    </div>
  );
}
